module.exports = __webpack_public_path__ + "img/07.ddcced92.png";